import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  // DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
  Typography,
  Grid,
  // Box,
  // IconButton,
  // makeStyles,
  // Paper,
  // TableContainer,
  // Table,
  // TableHead,
  // TableRow,
  // TableBody,
  // TableCell,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { presentFormatedData } from "../../functionalComponents/dataFormatFunctions";
import CustomDatePickerMui from "../../models/inputs/DateInput";
import { ChevronRight, Warning } from "@material-ui/icons";
import BackDropLoading from "../../models/BackDrop";
import { useDispatch } from "react-redux";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import jwtDecode from "jwt-decode";
//import dayjs from "dayjs";

// const useStyles = makeStyles((theme) => ({
//   tableContainer: {
//     // backgroundColor: "#e3eef3",
//     // padding: "10px",
//     // marginBottom: "10px",
//     boxShadow: "none",
//   },
//   tableCell: {
//     textAlign: "left",
//     backgroundColor: "#c2e1ef",
//     borderBottom: "none", // Remove bottom border
//     // width: '16.666%', // Set equal width for each cell
//     padding: "16px", // Standard padding for consistency
//   },
//   headerCell: {
//     fontWeight: "bold",
//     whiteSpace: "nowrap",
//   },
// }));

// const reasonCodes = [
//   {
//     reasonCode: "PP-014",
//     reasonDescription:
//       "Manufacturing slots not available as per PO requirements",
//   },
//   { reasonCode: "PP-015", reasonDescription: "Raw material shortage" },
//   { reasonCode: "PP-016", reasonDescription: "Production capacity issue" },
//   { reasonCode: "none", reasonDescription: "-" },
// ];

const PONegotiationDialogBox = ({ open, handleClose, row }) => {
  // const classes = useStyles();
  const dispatch = useDispatch();
  const originalPO = useRef(row);
  const [reasonCodes, setReasonCodes] = useState([
    // { reasonCode: "none", reasonDescription: "-", reasonCodeID: "none" },
  ]);
  const [proposedDate, setProposedDate] = useState(
    localStorage.collabType !== "CMO"
      ? row?.scheduleLineDetails?.sponsorProposedDeliveryDate
        ? row?.scheduleLineDetails?.sponsorProposedDeliveryDate
        : row?.scheduleLineDetails?.cmoProposedDeliveryDate
        ? row?.scheduleLineDetails?.cmoProposedDeliveryDate
        : row?.scheduleLineDetails?.committedDeliveryDate
        ? row?.scheduleLineDetails?.committedDeliveryDate
        : row?.scheduleLineDetails?.deliveryDate
      : row?.scheduleLineDetails?.cmoProposedDeliveryDate
      ? row?.scheduleLineDetails?.cmoProposedDeliveryDate
      : row?.scheduleLineDetails?.sponsorProposedDeliveryDate
      ? row?.scheduleLineDetails?.sponsorProposedDeliveryDate
      : row?.scheduleLineDetails?.committedDeliveryDate
      ? row?.scheduleLineDetails?.committedDeliveryDate
      : row?.scheduleLineDetails?.deliveryDate
  );
  const [proposedQty, setProposedQty] = useState(
    localStorage.collabType !== "CMO"
      ? row?.scheduleLineDetails?.sponsorProposedQuantity
        ? row?.scheduleLineDetails?.sponsorProposedQuantity
        : row?.scheduleLineDetails?.cmoProposedQuantity
        ? row?.scheduleLineDetails?.cmoProposedQuantity
        : row?.scheduleLineDetails?.committedQuantity
        ? row?.scheduleLineDetails?.committedQuantity
        : row?.scheduleLineDetails?.targetQuantity
      : row?.scheduleLineDetails?.cmoProposedQuantity
      ? row?.scheduleLineDetails?.cmoProposedQuantity
      : row?.scheduleLineDetails?.sponsorProposedQuantity
      ? row?.scheduleLineDetails?.sponsorProposedQuantity
      : row?.scheduleLineDetails?.committedQuantity
      ? row?.scheduleLineDetails?.committedQuantity
      : row?.scheduleLineDetails?.targetQuantity
  );
  const [selectedReason, setSelectedReason] = useState("none");
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [duplicateValueError, setDuplicateValueError] = useState(false);

  const isSameDate = (date1, date2) => {
    const d1 = new Date(date1).toISOString().split("T")[0]; // Extract YYYY-MM-DD
    const d2 = new Date(date2).toISOString().split("T")[0];
    return d1 === d2;
  };

  const changeInQty = (selectedLineitem) => {
    // originalValue = localStorage.collabType !== "CMO"
    //   ? selectedLineitem?.scheduleLineDetails?.sponsorProposedQuantity
    //     ? selectedLineitem?.scheduleLineDetails?.sponsorProposedQuantity
    //     : selectedLineitem?.scheduleLineDetails?.requestedQuantity
    //   : selectedLineitem?.scheduleLineDetails?.cmoProposedQuantity
    //     ? selectedLineitem?.scheduleLineDetails?.cmoProposedQuantity
    //   : selectedLineitem?.scheduleLineDetails?.requestedQuantity
    let result =
      localStorage.collabType !== "CMO"
        ? proposedQty ==
          selectedLineitem?.scheduleLineDetails?.sponsorProposedQuantity
          ? false
          : true
        : proposedQty ==
          selectedLineitem?.scheduleLineDetails?.cmoProposedQuantity
        ? false
        : true;

    return result;
  };

  const changeInDate = (selectedLineitem) => {
    let result =
      localStorage.collabType !== "CMO"
        ? proposedDate &&
          selectedLineitem?.scheduleLineDetails?.sponsorProposedDeliveryDate
          ? isSameDate(
              proposedDate,
              selectedLineitem?.scheduleLineDetails?.sponsorProposedDeliveryDate
            )
            ? false
            : true
          : proposedDate
          ? true
          : false
        : proposedDate &&
          selectedLineitem?.scheduleLineDetails?.cmoProposedDeliveryDate
        ? isSameDate(
            proposedDate,
            selectedLineitem?.scheduleLineDetails?.cmoProposedDeliveryDate
          )
          ? false
          : true
        : proposedDate
        ? true
        : false;

    return result;
  };

  // Validation function to check if proposed values match the other party's values
  const checkDuplicateValues = () => {
    if (localStorage.collabType === "CMO") {
      // CMO is proposing - check against Sponsor's values
      const sponsorQty = row?.scheduleLineDetails?.sponsorProposedQuantity;
      const sponsorDate = row?.scheduleLineDetails?.sponsorProposedDeliveryDate;
      
      // Check if both sponsor values exist
      if (sponsorQty && sponsorDate) {
      
        const qtyMatch = parseFloat(proposedQty) === parseFloat(sponsorQty);
        const dateMatch = isSameDate(proposedDate, sponsorDate);
        
      
        // Show error only when BOTH match (user must change at least one)
        return qtyMatch && dateMatch;
      }
      
      // If sponsor values don't exist, no need to validate
      return false;
    } else {
      // Sponsor is proposing - check against CMO's values
      const cmoQty = row?.scheduleLineDetails?.cmoProposedQuantity;
      const cmoDate = row?.scheduleLineDetails?.cmoProposedDeliveryDate;
      
      // Check if both CMO values exist
      if (cmoQty && cmoDate) {
        // Check if qty or date match
        const qtyMatch = parseFloat(proposedQty) === parseFloat(cmoQty);
        const dateMatch = isSameDate(proposedDate, cmoDate);
        
       
        // Show error only when BOTH match (user must change at least one)
        return qtyMatch && dateMatch;
      }
      
      // If CMO values don't exist, no need to validate
      return false;
    }
  };

  const handleSave = (type) => {
    // Check for duplicate values
    if (checkDuplicateValues()) {
      setDuplicateValueError(true);
      return;
    }

    // Validation: If reason code is "none", comment is mandatory
    if (selectedReason === "none" && !comment.trim()) {
      setError(true);
      return;
    }
    
    // Validation: For specific reason codes, comment is mandatory
    if (
      (localStorage.collabType === "CMO" &&
        selectedReason === "EXMRP031" &&
        !comment.trim()) ||
      (localStorage.collabType !== "CMO" &&
        selectedReason === "EXMRP019" &&
        !comment.trim())
    ) {
      setError(true);
      return;
    }
    
    // If validation passes, proceed with save
    setError(false);
    dispatch({
      type: OPEN_BACKDROP,
      // backdropText: `Please don't refresh or close the tab while processing`,
    });
    // setButtonDisabled(false);

    let selectedLineitem = originalPO.current ? originalPO.current : {};

    let data = {
        vendorMosymphonyID: row?.scheduleLineDetails?.vendorMosymphonyID,
        scheduleAgreementStatusID:
          row?.scheduleLineDetails?.scheduleLineStatusID,
        scheduleAgreementStatusText:
          row?.scheduleLineDetails?.scheduleLineStatusText,
        schrockenSAID: row?.scheduleLineDetails?.schrockenSAID,
        scheduleAgreementNumber:
          row?.scheduleLineDetails?.scheduleAgreementNumber,
        vendorName: row?.scheduleLineDetails?.vendorName,
        sponsorName: row?.scheduleLineDetails?.sponsorName,
        productsList: row?.scheduleLineDetails
          ? [
              {
                fgMaterialCode: row?.scheduleLineDetails?.fgMaterialCode,
                fgMaterialName: row?.scheduleLineDetails?.fgMaterialName,
              },
            ]
          : [],
        poLineEditFlag: true,
        acceptOfferFlag: false,
        rejectOfferFlag: false,
        approveFlag: false,
        shareWithCMOFlag: type === "sharedWithCMO" ? true : false,
        confirmedFlag: false,
        poApprovedFlag: [21, 22, 23].includes(
          row?.scheduleLineDetails?.scheduleLineStatusID
        )
          ? false
          : true,
        approvalWorkFlowDetails: [],
        SLDetails: {
          ...row?.scheduleLineDetails,
          reasonCode: selectedReason !== "none" ? selectedReason : null,
          comments: comment,
          sponsorProposedDeliveryDate:
            localStorage.collabType !== "CMO"
              ? proposedDate
              : row?.scheduleLineDetails?.sponsorProposedDeliveryDate,
          sponsorProposedQuantity:
            localStorage.collabType !== "CMO"
              ? proposedQty
              : row?.scheduleLineDetails?.sponsorProposedQuantity,

          cmoProposedDeliveryDate:
            localStorage.collabType !== "CMO"
              ? row?.scheduleLineDetails?.cmoProposedDeliveryDate
              : proposedDate,
          cmoProposedDeliveryDate:
            localStorage.collabType !== "CMO"
              ? row?.scheduleLineDetails?.cmoProposedDeliveryDate
              : proposedDate,
          cmoProposedQuantity:
            localStorage.collabType !== "CMO"
              ? row?.scheduleLineDetails?.cmoProposedQuantity
              : proposedQty,
          changeInQty: changeInQty(selectedLineitem),
          // localStorage.collabType !== "CMO"
          //   ? proposedQty ==
          //     selectedLineitem?.scheduleLineDetails?.sponsorProposedQuantity
          //     ? false
          //     : true
          //   : proposedQty ==
          //     selectedLineitem?.scheduleLineDetails?.cmoProposedQuantity
          //   ? false
          //   : true,

          changeInDate: changeInDate(selectedLineitem),
          // localStorage.collabType !== "CMO"
          //   ? proposedDate &&
          //     selectedLineitem?.scheduleLineDetails?.sponsorProposedDeliveryDate
          //     ? isSameDate(
          //       proposedDate,
          //         selectedLineitem?.scheduleLineDetails?.sponsorProposedDeliveryDate
          //       )
          //       ? false
          //       : true
          //     : proposedDate
          //     ? true
          //     : false
          //   : proposedDate &&
          //     selectedLineitem?.scheduleLineDetails?.cmoProposedDeliveryDate
          //   ? isSameDate(
          //     proposedDate,
          //       selectedLineitem?.scheduleLineDetails?.cmoProposedDeliveryDate
          //     )
          //     ? false
          //     : true
          //   : proposedDate
          //   ? true
          //   : false,
          markedForDelete: false,
        },
      };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updatePODetailsNew`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: DESTROY_BACKDROP,
          });

          handleClose("success");
        } else {
          handleClose("failed");
          dispatch({
            type: DESTROY_BACKDROP,
          });
        }
      })
      .catch((err) => {
        handleClose("failed");
        dispatch({
          type: DESTROY_BACKDROP,
        });
        // console.log(err);
      });

    // setTimeout(() => {
    //   dispatch({
    //     type: DESTROY_BACKDROP,
    //   });

    //   handleClose("success");
    // }, 3000);
  };
    const getOrganizationIdFromToken = () => {
        const authToken = localStorage.getItem("authToken"); // Get token from localStorage
        if (!authToken) return null; // Return null if no token is found
    
        try {
          const decodedToken = jwtDecode(authToken); // Decode the JWT token
          return decodedToken.collaborator_type_id || null; // Return collaborator_type_id or null if not found
        } catch (error) {
          console.error("Error decoding JWT token:", error);
          return null;
        }
      };
  const collaboratorTypeID = getOrganizationIdFromToken();

  useEffect(() => {
    const requestObject = {
      searchField: "all",
      searchValue: "",
      reasonCodeGroupType: "all",
      reasonCodeType: "all",
      status: "all",
      collaboratorTypeID: "all"
    };
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodes`,
        requestObject
      )
      .then((res) => {
        if (res.data.status) {
          if (
            Array.isArray(res.data?.data?.reasonCodeList) &&
            res.data?.data?.reasonCodeList.length > 0
          ) {
            setReasonCodes(reasonCodes.concat(res.data.data.reasonCodeList));
          }
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  }, []);

  const hasQuantityChanged = (selectedLineitem) => {
    const sponsorProposedQty =
      selectedLineitem?.scheduleLineDetails?.sponsorProposedQuantity;
    const cmoProposedQty =
      selectedLineitem?.scheduleLineDetails?.cmoProposedQuantity;

    // console.log(
    //   "Sponsor Proposed Quantity:",
    //   sponsorProposedQty,
    //   "CMO Proposed Quantity:",
    //   proposedQty
    // );

    // Ensure CMO changes the quantity from the sponsor's proposed quantity
    return (
      proposedQty !== undefined &&
      proposedQty !== null &&
      proposedQty !== sponsorProposedQty
    );
  };

  // Rename changeInDate to hasDateChanged
  const hasDateChanged = (selectedLineitem) => {
    const sponsorProposedDate =
      selectedLineitem?.scheduleLineDetails?.sponsorProposedDeliveryDate;
    const cmoProposedDate =
      selectedLineitem?.scheduleLineDetails?.cmoProposedDeliveryDate;

    // console.log(
    //   "Sponsor Proposed Date:",
    //   sponsorProposedDate,
    //   "CMO Proposed Date:",
    //   proposedDate
    // );

    // Ensure CMO changes the date from the sponsor's proposed date
    return (
      proposedDate !== undefined &&
      proposedDate !== null &&
      sponsorProposedDate !== null &&
      !isSameDate(proposedDate, sponsorProposedDate)
    );
  };
  // console.log(
  //   "hasQuantityChanged:",
  //   hasQuantityChanged(originalPO.current ?? {})
  // );
  // console.log("hasDateChanged:", hasDateChanged(originalPO.current ?? {}));
  // console.log("selectedReason:", selectedReason);
  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <BackDropLoading />
      <DialogContent>
        <Grid container justifyContent="flex-end">
          <Typography
            variant="body2"
            style={{
              fontSize: "1rem",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              handleClose();
            }}
          >
            Cancel <CloseIcon style={{ color: "#FF0000" }} fontSize="large" />
          </Typography>
        </Grid>
        <Typography
          style={{
            fontWeight: "500",
            color: "black",
            fontSize: "2rem",
            margin: "1rem",
            textAlign: "center",
          }}
        >
          Edit {localStorage.collabType !== "CMO" ? "Sponsor" : "CMO"} proposed
          values for PO {row?.scheduleLineDetails?.scheduleAgreementNumber}
        </Typography>
        <Grid container spacing={3} style={{ marginTop: "1rem" }}>
          <Grid item xs={4}>
            <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
              {localStorage.collabType !== "CMO" ? "Sponsor" : "CMO"} Proposed Qty
            </Typography>
            <TextField
              type="number"
              fullWidth
              value={proposedQty}
              //onChange={(e) => setProposedQty(e.target.value)}
              onChange={(e) => {
                const value = parseFloat(e.target.value);
                if (value > 0 || e.target.value === "") {
                  setProposedQty(e.target.value);
                  setDuplicateValueError(false);
                }
              }}
              onKeyDown={(e) => {
                if (["-", "+", "e", "E"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              variant="outlined"
              size="small"
              inputProps={{ min: 1 }}
            />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
              UoM
            </Typography>
            <Typography>
              {presentFormatedData(row?.scheduleLineDetails?.targetQuantityUOM)}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
              {localStorage.collabType !== "CMO" ? "Sponsor" : "CMO"} Proposed Date
            </Typography>
            {/* <CustomDatePickerMui
              fullWidth
              value={proposedDate}
              onChange={(date) =>
                setProposedDate(date.format("YYYY-MM-DD") + "T00:00")
              }
              // style={{ width: "150px" }}
              minDate={dayjs()}
            /> */}
            <CustomDatePickerMui
              fullWidth
              value={proposedDate}
              onChange={(date) => {
                setProposedDate(
                  date ? date.format("YYYY-MM-DD") + "T00:00" : ""
                );
                setDuplicateValueError(false);
              }}
              disablePast // ✅ disables all past dates
            />
          </Grid>
        </Grid>

        {duplicateValueError && (
          <Grid container style={{ marginTop: "0.5rem" }}>
            <Grid item xs={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Warning style={{ color: "#FF0000", fontSize: "24px" }} />
                <Typography style={{ color: "#FF0000", textAlign: "start" }}>
                  {localStorage.collabType === "CMO"
                    ? "Edited CMO Proposed Values are matching Sponsor Proposed Values. Please enter new values or accept Sponsor Proposed Values using the tick icon button."
                    : "Edited Sponsor Proposed Values are matching CMO Proposed Values. Please enter new values or accept CMO Proposed Values using the tick icon button."}
                </Typography>
              </div>
            </Grid>
          </Grid>
        )}

        <Grid container spacing={3} style={{ marginTop: "1rem" }}>
          <Grid item xs={4}>
            <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
              Reason code / Description
            </Typography>
            <TextField
              select
              fullWidth
              value={selectedReason}
              onChange={(e) => {
                setError(false);
                setSelectedReason(e.target.value);
              }}
              variant="outlined"
              size="small"
              displayEmpty
              error={error && selectedReason === "none"}
              helperText={
                error && selectedReason === "none" ? "Select reason code" : ""
              }
              style={{ width: "600px" }}
            >
              <MenuItem value="none" disabled>
                Select Reason Code / Description
              </MenuItem>
              {reasonCodes.map((reason) => (
                <MenuItem key={reason.reasonCodeID} value={reason.reasonCode}>
                  {reason.reasonCode} / {reason.reasonDescription || "-"}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          {/* <Grid item xs={8}>
            <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
              Reason code description
            </Typography>
            <Typography>
              {reasonCodes.find((r) => r.reasonCode === selectedReason)
                ?.reasonDescription || "-"}
            </Typography>
          </Grid> */}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
              Comment
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={3}
              value={comment}
              onChange={(e) => {
                setError(false);
                if(e.target.value.length < 256){
                setComment(e.target.value);
                }
              }}
              variant="outlined"
              size="small"
              error={error}
              placeholder="Enter text here"
              // helperText={error ? "Comment is mandatory if reason code is not selected." : ""}
            />
            <Typography variant="caption" style={{ color: error && "red" }}>
              Note - If reason code is not entered, comment field is mandatory.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: 16, justifyContent: "center" }}>
        <Button
          variant="contained"
          color="primary"
          // disabled={!proposedQty || !proposedDate}
          //</DialogActions>
          //  disabled={
          //!(
          // !(
          //   ["none"].includes(selectedReason) ||
          //   (["none", "other"].includes(selectedReason) && !comment.trim())
          // )

          disabled={
            !(
              // Case 1: Reason code is selected (not "none")
              (selectedReason !== "none" &&
                // If reason is EMXRP031 and user is CMO, comment must be filled
                ((selectedReason === "EXMRP031" &&
                  localStorage.collabType === "CMO" &&
                  comment.trim()) ||
                  // If reason is EXMRP019 and user is NOT CMO, comment must be filled
                  (selectedReason === "EXMRP019" &&
                    localStorage.collabType !== "CMO" &&
                    comment.trim()) ||
                  // For all other reasons, no comment check required
                  !["EXMRP031", "EXMRP019"].includes(selectedReason))) ||
              // Case 2: Reason code is not selected ("none") AND comment is entered
              (selectedReason === "none" && comment.trim())
            )
          }
          endIcon={<ChevronRight />}
          style={{
            borderRadius: "20px",
            textTransform: "none",
          }}
          onClick={() => {
            if (
              localStorage.collabType !== "CMO" &&
              row?.scheduleLineStatusID === 21
            ) {
              handleSave("sharedWithCMO");
            } else {
              handleSave();
            }
          }}
        >
          {localStorage.collabType !== "CMO" && row?.scheduleLineStatusID === 21
            ? "Save changes and share with CMO"
            : "Save changes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PONegotiationDialogBox;
